import MuseumIcon from "@mui/icons-material/Museum";
import RestaurantIcon from "@mui/icons-material/Restaurant";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import BeachAccessIcon from "@mui/icons-material/BeachAccess";
import DirectionsTransitIcon from "@mui/icons-material/DirectionsTransit";
import FortIcon from "@mui/icons-material/Fort";
import StadiumIcon from "@mui/icons-material/Stadium";
import StorefrontIcon from "@mui/icons-material/Storefront";

export const muiIconMap: Record<string, JSX.Element> = {
  MuseumIcon: <MuseumIcon />,
  RestaurantIcon: <RestaurantIcon />,
  LocationOnIcon: <LocationOnIcon />,
  BeachAccessIcon: <BeachAccessIcon />,
  DirectionsTransitIcon: <DirectionsTransitIcon />,
  FortIcon: <FortIcon />,
  StadiumIcon: <StadiumIcon />,
  StorefrontIcon: <StorefrontIcon />,
};
